//TODO update on each release change (QA and PROD)
export const version = '1.7.0'
